<script>
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import { companyListHeaders } from './config';
import CompanyListItem from './components/CompanyListItem';
import NewCompanyDialog from './components/NewCompanyDialog';

export default {
  name: 'CompanyList',
  components: {
    CompanyListItem,
    NewCompanyDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: companyListHeaders,
      showNewCompanyDialog: false,
    };
  },
  computed: {
    ...mapState(['companyList']),
    ...mapState('companyList', ['meta']),
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('companyList', { fetchData: 'fetchCompanyList' }),
  },
};
</script>

<template>
  <div class="company-list">
    <template v-if="companyList.hasError">
      <p class="js-error-template ma-3">Failed to fetch company list. Please try again!</p>
    </template>
    <template v-else>
      <!--<<v-toolbar dark dense height="40" color="blue-grey lighten-2">
        v-tooltip bottom>
          <v-btn icon slot="activator" @click="showNewCompanyDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Hinzufügen</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>
      </v-toolbar>-->

      <v-progress-linear
        v-if="companyList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="companyList.data"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="companyList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="items" slot-scope="props">
          <company-list-item :company="props.item" :expanded="props.expanded"/>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>
    </template>

    <NewCompanyDialog
      v-if="showNewCompanyDialog"
      @cancel="showNewCompanyDialog = false"
    />

  </div>
</template>
